/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Button } from "react-bootstrap";

export default function StickyToolbar(props) {
  return (
    <>
      <ul className="sticky-toolbar nav flex-column pl-2 pr-2 pt-3 pb-3 mt-4">
        <OverlayTrigger
          placement="left"
          target="hover"
          overlay={
            <Tooltip id="documentations-tooltip">
              Richiedi straordinario
            </Tooltip>
          }
        >
          <li className="nav-item mb-2" data-placement="left">
            <Button
              onClick={() => props.handleOpenStraordinarioShow()}
              className="btn btn-sm btn-icon btn-bg-secondary btn-text-warning btn-hover-success"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fas fa-business-time"></i>
            </Button>
          </li>
        </OverlayTrigger>

        <OverlayTrigger
          placement="left"
          target="hover"
          overlay={
            <Tooltip id="documentations-tooltip">Richiedi Permesso</Tooltip>
          }
        >
          <li className="nav-item mb-2" data-placement="left">
            <Button
              onClick={() => props.handleRichiestaOpen()}
              className="btn btn-sm btn-icon btn-bg-secondary btn-text-warning btn-hover-warning"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="flaticon2-time"></i>
            </Button>
          </li>
        </OverlayTrigger>

        <OverlayTrigger
          placement="left"
          target="hover"
          overlay={
            <Tooltip id="documentations-tooltip">Richiedi Ferie</Tooltip>
          }
        >
          <li className="nav-item mb-2" data-placement="left">
            <Button
              onClick={() => props.handleOpenFerieShow()}
              className="btn btn-sm btn-icon btn-bg-secondary btn-text-info btn-hover-info"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="flaticon2-world"></i>
            </Button>
          </li>
        </OverlayTrigger>

        <OverlayTrigger
          placement="left"
          target={["hover", "focus"]}
          overlay={
            <Tooltip id="documentations-tooltip">
              Aggiungi evento/avviso
            </Tooltip>
          }
        >
          <li className="nav-item mb-2" data-placement="left">
            <Button
              onClick={() => props.handleOpen()}
              className="btn btn-sm btn-icon btn-bg-secondary btn-text-primary btn-hover-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="flaticon2-calendar"></i>
            </Button>
          </li>
        </OverlayTrigger>
      </ul>
    </>
  );
}
